import { PlatformType } from 'videoservice-openapi-react';

export const platformTypes = Object.values(PlatformType);
